import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { JumpNRunMinigame } from '../StudentDashboard/JumpNRunMinigame';

const MinigamePage = ({ accessToken, claims }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.primary.main}15 100%)`,
                p: 2,
            }}
        >
            <JumpNRunMinigame accessToken={accessToken} claims={claims} />
        </Box>
    );
};

export default MinigamePage;
